import React from "react";
import { Image as AntImage } from "antd";
import PropTypes from "prop-types";

const Image = (props) => {
  return (
    <AntImage
      className={props.className ? props.className : null}
      src={props.src ? props.src : null}
      alt={props.alt ? props.alt : null}
      preview={false}
      placeholder={props.placeholder ? props.placeholder : null}
      fallback={props.loadingSrc ? props.loadingSrc : null}
      onClick={props.onClick ? props.onClick : null}
      onError={props.onError ? props.onError : null}
    />
  );
};

Image.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string,
  loadingSrc: PropTypes.string,
  onClick: PropTypes.func,
  onError: PropTypes.func,
  placeholder: PropTypes.node,
  className: PropTypes.string,
};

export default Image;
